import React from 'react';
import { Popup } from '@leverege/ui-elements';
import { SharedContext } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import useConditionFilterActionRenderer from "./useConditionFilterActionRenderer.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  tIcon,
  t
} = I18N.ns('molten.conditionFilter.ConditionActionRenderer');
function ConditionFilterActionRenderer({
  context
}) {
  const {
    conditionCount,
    conditionOptions,
    creators,
    delegate,
    editor,
    mobile,
    onPopupChange,
    opened,
    relationship
  } = useConditionFilterActionRenderer({
    context
  });
  return /*#__PURE__*/_jsx(SharedContext, {
    conditionOptions: conditionOptions,
    conditionCreators: creators,
    objectType: context.objectType,
    delegate: delegate,
    relationship: relationship,
    children: /*#__PURE__*/_jsx(Popup, {
      variant: "filter",
      opened: opened,
      onChange: onPopupChange,
      style: {
        color: conditionCount > 0 ? 'var(--color-filterApplied, var(--color-brand500, blue))' : undefined
      },
      toggleVariant: mobile ? 'mobileFilter|mobileActionBar' : 'filter|sortFilterBar|actionBar',
      icon: tIcon('filterIcon', 'fa fa-fw fa-filter'),
      title: t('nameWithCount', {
        count: conditionCount
      }),
      children: editor
    })
  });
}
export default /*#__PURE__*/React.memo(ConditionFilterActionRenderer);